import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash;
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login");
            return;
        }
        const sessionId = match[1];

        (async () => {
            try {
                const res = await api.post("/auth/session", { session_id: sessionId });
                if (res.data?.session_token) {
                    localStorage.setItem("pas_session_token", res.data.session_token);
                }
                setUser(res.data.user);
                // Clear the hash
                window.history.replaceState(null, "", "/dashboard");
                navigate("/dashboard", { replace: true, state: { user: res.data.user } });
            } catch (e) {
                const msg = e?.response?.data?.detail || "Authentication failed";
                setError(msg);
                setTimeout(() => navigate("/login"), 2500);
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
            <div className="bg-white border border-slate-200 rounded-lg shadow-sm p-8 max-w-md w-full text-center">
                {error ? (
                    <>
                        <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border bg-red-100 text-red-800 border-red-200">
                            Sign in failed
                        </div>
                        <p className="mt-4 text-slate-900 font-medium">{error}</p>
                        <p className="mt-2 text-slate-500 text-sm">Redirecting to login…</p>
                    </>
                ) : (
                    <>
                        <Loader2 className="h-8 w-8 text-[#2EB4AC] animate-spin mx-auto" />
                        <p className="mt-4 font-heading font-semibold text-slate-900">Signing you in…</p>
                        <p className="mt-1 text-slate-500 text-sm">Verifying your Odyssey account</p>
                    </>
                )}
            </div>
        </div>
    );
};

export default AuthCallback;
